var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex flex-column align-items-center"},[_c('v-chart',{ref:"bar",style:(("width: " + _vm.width + "; height: " + _vm.height + ";")),attrs:{"autoresize":"","option":_vm.option,"auto-resize":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }